import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { ExclamationTriangleFill as Alert, Check, DashCircleFill as Cancel } from "react-bootstrap-icons";
import { setDialog } from '../../store/api/GetAllProduct';
const ModalDialog = () => {
    const openDialog = useSelector(state => state.popup?.openDialog) ?? {};
    const { status, arrayBtn, dialogText, autoClose, dialogTitle, multiLine } = openDialog;
    const dispatch = useDispatch();
    const handleModal = () => {
        if (openDialog.okOperation !== undefined) {
            dispatch(openDialog.okOperation);
        }

        dispatch(setDialog({ status: 'hide' }));
    }
    const handleCancel = () => {
        if (typeof (openDialog.cancelOperation) === "function") {
            openDialog.cancelOperation();
        }
        dispatch(setDialog({ status: 'hide' }));
    }

    useEffect(() => {
        if (autoClose) {
            setTimeout(() => {
                dispatch(setDialog({ status: 'hide' }));
            }, 1000)
        }
    }, [status])

    return (
        <Modal show={status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle' style={{ display: 'inline-block', color: 'white', padding: '0.6rem 0.6rem' }}><Alert size={22} style={{ color: 'rgb(255 178 4)' }} />&nbsp;&nbsp;{dialogTitle}</Modal.Header>
            <Modal.Body>
                {multiLine ?
                    <div style={{ color: "black" }}>
                        {dialogText.split("\n").map((line, key) => <p key={key} style={{ color: "black" }}>{line}</p>)}
                    </div> :
                    <label>{dialogText}</label>}
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start" }}>
                {arrayBtn && arrayBtn.includes("yes") && <Button variant="info" style={{ fontSize: "12px", paddingRight: '1px' }} onClick={handleModal}><Check size={21} />بله</Button>}
                {arrayBtn && arrayBtn.includes("no") && <Button variant="danger" style={{ fontSize: "12px", padding: '0.47rem 0.47rem' }} onClick={handleCancel}><Cancel size={15} /> &nbsp;خیر</Button>}
                {arrayBtn && arrayBtn.includes("ok") && <Button style={{ fontSize: "12px" }} onClick={() => handleModal()}>متوجه شدم</Button>}
            </Modal.Footer>
        </Modal>
    )
}
export default ModalDialog;